export default {
  MANDATORY: 'mandatory',
  DEPOSIT: 'deposit',
};



// WEBPACK FOOTER //
// ./src/variables/ski/pass/key-card-payment-type-enums.js